import * as Tabs from '@radix-ui/react-tabs';
import classNames from 'classnames';

import styles from './TabsSolid.module.css';

interface TabRootProps extends Tabs.TabsProps {
  colorScheme?: 'accent' | 'black';
}

export function TabRoot({ colorScheme = 'accent', className, ...props }: TabRootProps) {
  return (
    <Tabs.Root
      className={classNames(styles.tabsRoot, styles[colorScheme], className || '')}
      {...props}
    />
  );
}

TabRoot.defaultProps = {
  colorScheme: 'accent',
};

export function TabList({ className, ...props }: Tabs.TabsListProps) {
  return <Tabs.List className={classNames(styles.tabsList, className || '')} {...props} />;
}

export function TabTrigger({ className, ...props }: Tabs.TabsTriggerProps) {
  return <Tabs.Trigger className={classNames(styles.tabsTrigger, className || '')} {...props} />;
}

export function TabContent({ className, ...props }: Tabs.TabsContentProps) {
  return <Tabs.Content className={classNames(styles.tabsContent, className || '')} {...props} />;
}
